import Navbar from "@/components/Navbar";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import Hero from "@/components/sections/Hero";
import Segmentos from "@/components/sections/Segmentos";
import Produtos from "@/components/sections/Produtos";
import Diferenciais from "@/components/sections/Diferenciais";
import Sobre from "@/components/sections/Sobre";
import CTA from "@/components/sections/CTA";
import Footer from "@/components/sections/Footer";

export default function Home() {
  return (
    <div data-testid="home-page" className="min-h-screen bg-[#f5efe1]">
      <Navbar />
      <main>
        <Hero />
        <Segmentos />
        <Produtos />
        <Diferenciais />
        <Sobre />
        <CTA />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
